<template>
  <div class="summary white-box position-relative">
    <TileLoader :loading="loading"/>
    <div class="header-container">
      <h2>Prestations</h2>
      <p>{{ formatEuro(totalPrestationsCA) }}</p>
    </div>

    <div class="bar-container">
      <div class="bar">
        <div class="filled-bar" :style="{width: (percentPaidCA + '%')}"></div>
        {{ percentPaidCA }} %
      </div>
    </div>

    <div class="details">
      <div class="numbers-grid">
        <div>Non payés</div>
        <div>{{ totalUnpaidPrestationsCount }}</div>
        <div>{{ formatEuro(totalUnpaidPrestationsCA) }}</div>
        <div>Payés</div>
        <div>{{ totalPaidPrestationsCount }}</div>
        <div>{{ formatEuro(totalPaidPrestationsCA) }}</div>
      </div>
      <div>
        <a v-if="currentYearPeriod"
           target="_blank"
           rel="noreferrer"
           :href="getDroneRedirectUrl('campaign/' + currentYearPeriod.campaignGuid + '/facturations')"
        >
          <button class="btn-cmem">
            Voir la liste<br/>complète
          </button>
        </a>
      </div>
    </div>

    <div v-if="mostUnpaidSupplier" class="most-unpaid">
      <span>Plus gros impayé</span>
      <span>{{ mostUnpaidSupplier.Name }}</span>
      <span>{{ formatEuro(mostUnpaidSupplier.TotalTTC - mostUnpaidSupplier.TotalPaid) }}</span>
    </div>
  </div>
</template>

<script>

import {getPrestations} from "@/utils/dashboardCdm";
import TileLoader from "../../Dashboards/TileLoader.vue";
import {getDroneRedirectUrl} from "@/helpers/getRedirectUrlHelper";
import store from "@/store/dashboards";

export default {
  components: {
    TileLoader
  },
  props: ["year", "currentYearPeriod"],
  data() {
    return {
      loading: true,
      prestationsBySupplier: [],
      store
    }
  },
  mounted() {
    this.initData()
  },
  watch: {
    year() {
      this.initData();
    },
    storeGlobalView() {
      this.initData();
    }
  },
  methods: {
    getDroneRedirectUrl,
    initData() {
      if (!this.year) return;
      this.loading = true;

      getPrestations(this.year, this.storeGlobalView).then(res => {
        this.prestationsBySupplier = res;
        this.loading = false;
      })
    },
    formatEuro(value) {
      return Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'}).format(value);
    }
  },
  computed: {
    storeGlobalView() {
      return this.store.globalView;
    },
    totalPrestationsCA() {
      return this.prestationsBySupplier.reduce((acc, cur) => acc + cur.TotalTTC, 0);
    },
    totalPaidPrestationsCA() {
      return this.prestationsBySupplier.reduce((acc, cur) => acc + cur.TotalPaid, 0);
    },
    totalPaidPrestationsCount() {
      return this.prestationsBySupplier.filter(p => !!p.Paid).length;
    },
    totalUnpaidPrestationsCA() {
      return this.prestationsBySupplier.reduce((acc, cur) => acc + (cur.TotalTTC - cur.TotalPaid), 0);
    },
    totalUnpaidPrestationsCount() {
      return this.prestationsBySupplier.filter(p => !p.Paid).length;
    },
    mostUnpaidSupplier() {
      let maxUnpaid = 0;
      let res = null;

      for (let frs of this.prestationsBySupplier) {
        let unpaidCA = frs.TotalTTC - frs.TotalPaid;
        if (unpaidCA > maxUnpaid) {
          maxUnpaid = unpaidCA;
          res = frs;
        }
      }

      return res;
    },
    percentPaidCA() {
      if (this.totalPrestationsCA == 0) return 0;
      return Math.round(this.totalPaidPrestationsCA / this.totalPrestationsCA * 100);
    }
  }
}

</script>

<style scoped>
.white-box {
  flex: 1 1 25em;
}

.header-container {
  display: flex;
  justify-content: space-between;
  column-gap: 16px;
}

h2 {
  font-size: 20px;
  border-left: 3px solid #A7C13C;
  padding-left: 4px;
}

.bar-container {
  margin-top: 12px;
  width: max(280px, 100%);
}

.bar-container .bar {
  position: relative;
  height: 24px;
  width: 100%;
  background-color: #E5E5E5;
  border-radius: 3px;
  overflow: hidden;
  z-index: 1;

  text-align: center;
}

.bar-container .bar .filled-bar {
  position: absolute;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(90.37deg, #A7C13C 0.06%, #7BD276 99.94%);
  z-index: -1;
}

.details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 24px;
  margin-top: 12px;
}

.details .numbers-grid {
  display: grid;
  grid-template-columns: max-content max-content max-content;
  column-gap: 16px;
  row-gap: 4px;
}

.details .numbers-grid > div:nth-child(3n - 2) {
  font-weight: bold;
}

.details .numbers-grid > div:nth-child(3n - 1),
.details .numbers-grid > div:nth-child(3n) {
  text-align: right;
}

.most-unpaid {
  margin-top: 12px;
  display: grid;
  grid-template-columns: max-content max-content max-content;
  column-gap: 16px;
  font-size: 0.9em;
}

</style>



// WEBPACK FOOTER //
// src/components/DashboardCdm/Prestations/PrestationsTile.vue